import { render, staticRenderFns } from "./mainPanel.vue?vue&type=template&id=cb70b03c&scoped=true"
import script from "./mainPanel.vue?vue&type=script&lang=js"
export * from "./mainPanel.vue?vue&type=script&lang=js"
import style0 from "./mainPanel.vue?vue&type=style&index=0&id=cb70b03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb70b03c",
  null
  
)

export default component.exports